// extracted by mini-css-extract-plugin
export var boldText = "_6r-4";
export var checkboxContainer = "_6r-6";
export var closeIcon = "_6r-i";
export var container = "_6r-0";
export var drawer = "_6r-8";
export var drawerContent = "_6r-9";
export var extraSmallText = "_6r-5";
export var fulfillmentGroupTable = "_6r-e";
export var largeText = "_6r-3";
export var loadingSpinnerContainer = "_6r-j";
export var mediumText = "_6r-2";
export var narrow = "_6r-f";
export var notificationLink = "_6r-l";
export var packageCheckIconContainer = "_6r-7";
export var slideoutHeaderActions = "_6r-g";
export var slideoutHeaderActionsShifted = "_6r-h";
export var slideoutHeaderContainer = "_6r-a";
export var slideoutModal = "_6r-c";
export var stickyHeaderWrapper = "_6r-b";
export var table = "_6r-k";
export var tableContainer = "_6r-d";
export var tertiaryText = "_6r-1";